/**
 * Reads the Rails/Devise CSRF token out of the `_csrf_token` cookie so it can
 * be attached to state-changing requests (e.g. unlock instructions/confirm).
 */
export function getCsrfToken(): string {
  const match = document.cookie.match(/_csrf_token=([^;]+)/)
  return match ? decodeURIComponent(match[1]) : ''
}
